import React from 'react';
import { enUS } from '.';
import { useContext } from 'react';
export const LocaleContext = React.createContext(enUS);
export function useLocale(namespace) {
    const locale = useContext(LocaleContext);
    return locale[namespace]; // not using memo for basic property getter
}
